export const profile = {
  'Top artists this month': 'Principales artistas de este mes',
  'Top tracks this month': 'Principales canciones de este mes',
  Songs: 'Canciones',
  'Only visible to you': 'Solo visible para ti',
  'Public playlists': 'Playlists públicas',
  Profile: 'Perfil',
  Followers: 'Seguidores',
  'See all': 'Mostrar más',
};
